export const homeObjOne = {
  headline: "ژانر تاریخی",
  description:
    "مجموعهٔ رخدادهای فرهنگی، طبیعی، اجتماعی، اقتصادی و سیاسی و رویدادهایی است که در گذشته و در زمان و مکان زندگی انسان‌ها و در رابطه با آن‌ها رخ داده‌است. این رویدادها شامل اموری می‌شود از قبیل کردارها و دستاوردهای مادی و معنوی بشر و هرآنچه که گفته، اندیشیده و عمل کرده‌است.",
  imgStart: "",
  img: require("./images/hero.png").default,
  alt: "تصویر کتاب تاریخی",
  start: "",
};
